<template>
  <AppFormGroup>
    <SubHeading keypath="headings.employment" />

    <div class="flex flex-col lg:flex-row lg:gap-4">
      <AppField
        :path-prefix="applicantType"
        path="employment.employerName"
        class="lg:grow"
      />

      <AppField
        :path-prefix="applicantType"
        path="employment.jobTitle"
        class="lg:grow"
      />

      <AppField
        :path-prefix="applicantType"
        path="employment.employerPhone"
        class="lg:grow"
      />

      <AppField
        :path-prefix="applicantType"
        path="employment.employerPhoneExtension"
      />
    </div>
  </AppFormGroup>
</template>

<script setup lang="ts">
  import { useProviderI18n } from "@versatile-credit-apply/sdk"
  import type { FormSectionProps } from "./form-section-api"
  import {
    AppFormGroup,
    AppField,
  } from "@versatile-credit-apply/components/form"

  const props = defineProps<FormSectionProps>()

  useProviderI18n(() => props.providerKey)
</script>

<i18n lang="yaml" locale="en">
appFields:
  employerName:
    label: Employer Name
  employerPhone:
    label: Employer Phone Number
  employerPhoneExtension:
    label: Ext
  jobTitle:
    label: Job Title
headings:
  employment: Employer
</i18n>

<i18n lang="yaml" locale="tdbank_standard_en">
appFields:
  jobTitle:
    label: Occupation
</i18n>
